import { useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import {
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Box,
  Divider
} from "@mui/material";

export default function ResetPasswordPage() {
  const location = useLocation();
  const token = new URLSearchParams(location.search).get("token");

  const [pass1, setPass1] = useState("");
  const [pass2, setPass2] = useState("");
  const [message, setMessage] = useState("");

  const submit = async () => {
    if (!pass1 || !pass2) return setMessage("Lütfen tüm alanları doldurun.");
    if (pass1 !== pass2) return setMessage("Şifreler eşleşmiyor.");

    try {
      await axios.post("https://api.haymestasarim.com/api/auth/reset-password", {
        token,
        sifre: pass1,
      });

      setMessage("Şifreniz başarıyla yenilendi. Giriş yapabilirsiniz.");
    } catch (err) {
      setMessage("Şifre yenileme başarısız. Token geçersiz olabilir.");
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#f5f5f5",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 2,
      }}
    >
      <Card sx={{ width: 380, padding: 2, boxShadow: 4, borderRadius: 2 }}>
        
        <Box sx={{ textAlign: "center", marginBottom: 2 }}>
          <img
            src="/logo.png"
            alt="Logo"
            style={{ width: 80, opacity: 0.9 }}
          />
        </Box>

        <CardContent>
          <Typography
            variant="h6"
            align="center"
            sx={{ fontWeight: 600, marginBottom: 2 }}
          >
            Yeni Şifre Oluştur
          </Typography>

          <Divider sx={{ marginBottom: 2 }} />

          <TextField
            label="Yeni Şifre"
            type="password"
            fullWidth
            margin="normal"
            value={pass1}
            onChange={(e) => setPass1(e.target.value)}
          />

          <TextField
            label="Şifre Tekrar"
            type="password"
            fullWidth
            margin="normal"
            value={pass2}
            onChange={(e) => setPass2(e.target.value)}
          />

          <Button
            variant="contained"
            fullWidth
            sx={{
              marginTop: 2,
              padding: "10px",
              bgcolor: "#1976d2",
              ":hover": { bgcolor: "#125aa0" },
            }}
            onClick={submit}
          >
            Şifreyi Güncelle
          </Button>

          {message && (
            <Typography
              sx={{
                marginTop: 2,
                color: message.includes("başarıyla") ? "green" : "red",
                fontSize: 14,
              }}
            >
              {message}
            </Typography>
          )}
        </CardContent>
      </Card>
    </Box>
  );
}
